import * as React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';
import { ROUTES } from 'config/routes';
import {
	AuthenticationHandler,
	ConditionalRoute,
	ProtectedRoute
} from '../../containers';
import { Pages } from '..';
import { IRootState } from 'store';
import * as App from 'application';
import { StaticRouterProps, withRouter } from 'react-router';
import { parse as parseQueryString } from 'query-string';

export interface IContentViewProps extends StaticRouterProps {
	isAuthenticated: boolean;
	isUserLoaded: boolean;
	isPendingEmail: boolean;
	isHasSubscription: boolean;
}

const mapStateToProps = (state: IRootState) => ({
	isPendingEmail: App.User.isPendingEmailConfirmation(state),
	isHasSubscription: App.User.hasSubscriptions(state),
	isAuthenticated: App.Authentication.isAuthenticated(state),
	isUserLoaded: App.User.isLoaded(state),
});

/** Component showing application content (switching between routes/different content views) */
const ContentViewComponent: React.SFC<IContentViewProps> = (props) => {
	const { isAuthenticated, isPendingEmail, isHasSubscription, isUserLoaded } = props;
	const loc = props.location as any
	const queryValues = parseQueryString(loc.search);
	const protectedProps = {
		currentPath: loc.pathname,
		isAuthenticated,
		isHasSubscription,
		isPendingEmail,
		isUserLoaded,
		queryValues
	}

	console.debug("Content Routing PATH:[" + loc.pathname + "]");
	console.debug(props.location);
	const result = (
		<Switch>
			<ConditionalRoute path={ROUTES.LANDING} exact isTrue={!isAuthenticated} altPath={ROUTES.HOME} component={Pages.Landing} />
			<ConditionalRoute path={ROUTES.SIGNUP} isTrue={!isAuthenticated} altPath={ROUTES.HOME} render={() => <Pages.Landing isShowSignUp={true} queryValues={queryValues} />} />
			<ConditionalRoute path={ROUTES.LOGIN} isTrue={!isAuthenticated} altPath={ROUTES.HOME} render={() => <Pages.Landing isShowLogin={true} queryValues={queryValues} />} />

			<Route path={ROUTES.AUTHENTICATE} component={AuthenticationHandler} />
			<Route path="/theme" component={Pages.TestThemeView} />
			<ProtectedRoute {...protectedProps} path={ROUTES.EMAIL_PENDING} component={Pages.EmailPending} />
			<ProtectedRoute {...protectedProps} path={ROUTES.SUBSCRIBE} component={Pages.PlanSubscription} />
			<ProtectedRoute {...protectedProps} path={ROUTES.SETTINGS} component={Pages.AccountSettings} />
			<ProtectedRoute {...protectedProps} path={ROUTES.HOME} component={Pages.Download} />

			<Route path={ROUTES.EMAIL_CONFIRMATION} render={() => <Pages.EmailConfirmation isAuthenticated={isAuthenticated} />} />
			{/* Any Other => Unknown => Go TO Landing  */}
			<Route render={() => <Redirect to={ROUTES.LANDING} />} />
		</Switch>
	);
	return result;
};
const reduxComp = connect(mapStateToProps)(ContentViewComponent);
export const ContentView = withRouter<any>(reduxComp);	//this makes sure component re-renders when route changes


// WEBPACK FOOTER //
// ./src/components/presentational/application/ContentView.tsx